import { render, staticRenderFns } from "./Collaborate.vue?vue&type=template&id=abb4f874&scoped=true"
import script from "./Collaborate.vue?vue&type=script&lang=js"
export * from "./Collaborate.vue?vue&type=script&lang=js"
import style0 from "./Collaborate.vue?vue&type=style&index=0&id=abb4f874&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb4f874",
  null
  
)

export default component.exports